export default "__VITE_ASSET__DtMr_xoX__"